// Function to update size availability based on selected color
function updateOptionAvailability(optionToUpdate, selectedOptionName, selectedOptionValue) {
  // RE-ENABLED: This function handles sold-out styling for size options
  // Price updates are now handled by product-variant-sync.js to prevent conflicts

  const optionInputs = document.querySelectorAll(`input[data-option-name="${optionToUpdate}"]`);

  // Get the index of the option to update and the selected option
  const updateIndex = window.productData.optionNames.indexOf(optionToUpdate);
  const selectedIndex = window.productData.optionNames.indexOf(selectedOptionName);

  if (updateIndex < 0 || selectedIndex < 0) {
    return;
  }

  optionInputs.forEach(input => {
    const label = document.querySelector(`label[for="${input.id}"]`);
    const currentOptionValue = input.value;

    if (!label) {
      return;
    }

    let isAvailable = false;
    let matchingVariants = [];
    let allCheckedVariants = [];

    if (window.productData && window.productData.variants) {
      // First, show ALL variants grouped by style for debugging
      if (currentOptionValue === 'Newborn') { // Only log once to avoid spam

        const variantsByStyle = {};
        window.productData.variants.forEach(variant => {
          const style = variant.options[0];
          if (!variantsByStyle[style]) {
            variantsByStyle[style] = [];
          }
          variantsByStyle[style].push({
            id: variant.id,
            style: variant.options[0],
            size: variant.options[1],
            available: variant.available,
            options: variant.options
          });
        });
        Object.keys(variantsByStyle).forEach(style => {
        });
      }
      
      window.productData.variants.forEach((variant, idx) => {
        const variantSelectedValue = variant.options[selectedIndex];
        const variantUpdateValue = variant.options[updateIndex];
        const matchesSelected = variantSelectedValue === selectedOptionValue;
        const matchesUpdate = variantUpdateValue === currentOptionValue;
        const matchesBoth = matchesSelected && matchesUpdate;
        
        // Log ALL matching variants (not just first 5)
        if (matchesBoth) {
          // Calculate actual availability based on inventory
          let actualAvailable = variant.available;
          let availabilityReason = '';
          
          // Check all possible inventory properties
          const inventoryQty = variant.inventory_quantity !== undefined ? variant.inventory_quantity : null;
          const inventoryMgmt = variant.inventory_management !== undefined ? variant.inventory_management : null;
          const inventoryPolicy = variant.inventory_policy !== undefined ? variant.inventory_policy : null;
          
          // If inventory is tracked AND we have quantity data, check inventory quantity
          if (inventoryMgmt !== null && inventoryMgmt !== '' && inventoryQty !== null) {
            // Inventory is tracked AND we have quantity data - check if quantity > 0
            actualAvailable = (inventoryQty > 0);
            availabilityReason = `inventory tracked with qty data: qty=${inventoryQty}, available=${actualAvailable}`;
          } else if (inventoryMgmt !== null && inventoryMgmt !== '' && inventoryQty === null) {
            // Inventory is tracked BUT quantity is null (not in JSON) - trust variant.available
            // This happens when Liquid doesn't include inventory_quantity in the JSON
            actualAvailable = variant.available;
            availabilityReason = `inventory tracked but qty=null (not in JSON), using variant.available=${variant.available}`;
          } else if (inventoryPolicy === 'continue') {
            // Allow backorders - always available
            actualAvailable = true;
            availabilityReason = 'inventory policy: continue (allow backorders)';
          } else {
            // Inventory not tracked or deny policy - use the available flag
            actualAvailable = variant.available;
            availabilityReason = `inventory not tracked, using variant.available=${variant.available}`;
          }

        }
        
        if (matchesBoth) {
          // Calculate actual availability
          let actualAvailable = variant.available;
          
          // Check all possible inventory properties
          const inventoryQty = variant.inventory_quantity !== undefined ? variant.inventory_quantity : null;
          const inventoryMgmt = variant.inventory_management !== undefined ? variant.inventory_management : null;
          const inventoryPolicy = variant.inventory_policy !== undefined ? variant.inventory_policy : null;
          
          // If inventory is tracked AND we have quantity data, check inventory quantity
          if (inventoryMgmt !== null && inventoryMgmt !== '' && inventoryQty !== null) {
            // Inventory is tracked AND we have quantity data - check if quantity > 0
            actualAvailable = (inventoryQty > 0);
          } else if (inventoryMgmt !== null && inventoryMgmt !== '' && inventoryQty === null) {
            // Inventory is tracked BUT quantity is null (not in JSON) - trust variant.available
            // This happens when Liquid doesn't include inventory_quantity in the JSON
            actualAvailable = variant.available;
          } else if (inventoryPolicy === 'continue') {
            // Allow backorders - always available
            actualAvailable = true;
          } else {
            // Use variant.available as fallback
            actualAvailable = variant.available;
          }
          
          matchingVariants.push({
            id: variant.id,
            available: variant.available,
            actualAvailable: actualAvailable,
            inventory_quantity: inventoryQty,
            inventory_management: inventoryMgmt,
            inventory_policy: inventoryPolicy,
            options: variant.options,
            selectedValue: variantSelectedValue,
            updateValue: variantUpdateValue
          });
          
          // Use actualAvailable instead of just variant.available
          if (actualAvailable) {
            isAvailable = true;
          }
        }
      });
    } else {

    }

    if (matchingVariants.length === 0) {
    } else if (!isAvailable && matchingVariants.length > 0) {

    }

    // Apply the availability state
    if (isAvailable) {
      label.classList.remove('sold-out');
      input.classList.remove('is-unavailable');
      label.classList.remove('is-unavailable');
      input.disabled = false;
      label.style.background = '';
      label.style.pointerEvents = '';
      label.style.cursor = '';
      label.style.opacity = '';
      const strikeElement = label.querySelector('.sold-out-strike');
      if (strikeElement) {
        strikeElement.remove();
      }

    } else {
      label.classList.add('sold-out');
      input.classList.add('is-unavailable');
      label.classList.add('is-unavailable');
      // Keep input enabled so clicks can trigger BIS signup
      // Don't disable - we want clicks to work for BIS signup
      input.disabled = false;
      // Allow pointer events so clicks work for BIS signup
      label.style.pointerEvents = '';
      label.style.cursor = 'pointer';
      label.style.opacity = '0.6';
      label.style.background = 'linear-gradient(to bottom left, #EEEEEE calc(50% - 1px), rgba(var(--text-color) / .2) calc(50% - 1px), rgba(var(--text-color) / .2) calc(50% + 1px), #EEEEEE calc(50% + 1px)) no-repeat';
      if (!label.querySelector('.sold-out-strike')) {
        const strikeElement = document.createElement('span');
        strikeElement.className = 'sold-out-strike';
        label.appendChild(strikeElement);
      }

    }
    
    // Verify the state was applied correctly
    const hasSoldOutClass = label.classList.contains('sold-out');
    const hasUnavailableClass = label.classList.contains('is-unavailable');
    const inputHasUnavailable = input.classList.contains('is-unavailable');
    
    if (isAvailable && (hasSoldOutClass || hasUnavailableClass || inputHasUnavailable)) {
    } else if (!isAvailable && (!hasSoldOutClass || !hasUnavailableClass || !inputHasUnavailable)) {

    } else {

    }
  });

}

// Wrap event listeners and initial setup in DOMContentLoaded

// Also try immediate setup if DOM is already loaded
if (document.readyState === 'loading') {
} else {

}

document.addEventListener('DOMContentLoaded', function() {
  // Handle color swatch selection for combined products AND standard products
  const colorSwatchLabels = document.querySelectorAll('.opt-label--swatch');
  
  colorSwatchLabels.forEach((label, index) => {
    label.addEventListener('click', function(e) {
      // Get the value from the associated radio input
      const radioInput = document.querySelector(`input[id="${this.getAttribute('for')}"]`);
      let colorValue = null;
      
      if (radioInput) {
        colorValue = radioInput.value;
      }
      
      // Check if this is a combined product (has href) or single product (no href)
      const isCombinedProduct = this.hasAttribute('href') && this.href;
      
      if (isCombinedProduct) {
        // For combined products, let the navigation happen naturally
        colorSwatchLabels.forEach(swatch => {
          swatch.classList.remove('is-selected');
        });
        this.classList.add('is-selected');
        return;
      }
      
      // For single products (labels), prevent default behavior and sync with radio buttons
      e.preventDefault();
      
      // Find and check the corresponding radio button
      const radioButton = document.querySelector(`input[data-option-name="Color"][value="${colorValue}"], input[data-option-name="Colour"][value="${colorValue}"]`);
      
      if (radioButton) {
        // Update visual selection first
        colorSwatchLabels.forEach(swatch => {
          swatch.classList.remove('is-selected');
        });
        this.classList.add('is-selected');
        
        // Update color text display
        const colorTextElement = document.querySelector('.js-color-text');
        if (colorTextElement && colorValue) {
          colorTextElement.textContent = colorValue;
        }
        
        // Check the radio button and let the existing theme code handle everything else
        radioButton.checked = true;
        
        // Trigger the existing change event first
        radioButton.dispatchEvent(new Event('change', { bubbles: true }));
        
        // Also trigger our variant sync handler
        setTimeout(() => {
          const variantChangeEvent = new CustomEvent('variant:sync', {
            detail: { 
              optionName: 'Color',
              optionValue: colorValue,
              radioButton: radioButton
            },
            bubbles: true
          });
          document.dispatchEvent(variantChangeEvent);
        }, 10);
        
        // MANUAL VARIANT SYNC: Always run this to ensure proper variant detection
        setTimeout(() => {
          // Get all currently selected options
          const selectedOptions = {};
          document.querySelectorAll('input[data-option-name]:checked').forEach(input => {
            selectedOptions[input.dataset.optionName] = input.value;
          });
          
          // Find the matching variant
          let matchingVariant = null;
          if (window.productData && window.productData.variants) {
            for (const variant of window.productData.variants) {
              let matches = true;
              
              // Dynamic matching based on actual option positions
              Object.keys(selectedOptions).forEach(optionName => {
                const optionIndex = window.productData.optionNames.indexOf(optionName);
                if (optionIndex >= 0) {
                  const variantOptionValue = variant.options[optionIndex];
                  if (variantOptionValue !== selectedOptions[optionName]) {
                    matches = false;
                  }
                }
              });
              
              if (matches) {
                matchingVariant = variant;
                break;
              }
            }
          }
          
          if (matchingVariant) {
            // Update the hidden variant ID input
            const variantIdInput = document.querySelector('input[name="id"]');
            if (variantIdInput) {
              const oldValue = variantIdInput.value;
              variantIdInput.value = matchingVariant.id;
              
              // Update URL
              const currentUrl = new URL(window.location);
              currentUrl.searchParams.set('variant', matchingVariant.id);
              window.history.replaceState(null, '', currentUrl.toString());
              
              // Update add to cart button
              const addToCartBtn = document.querySelector('[name="add"], .product-form__cart-submit');
              if (addToCartBtn) {
                addToCartBtn.disabled = !matchingVariant.available;
                if (!matchingVariant.available) {
                  addToCartBtn.textContent = 'Sold Out';
                } else {
                  addToCartBtn.textContent = 'Add to Cart';
                }
              }
              
              // ALWAYS trigger the media gallery with the correct variant (even if ID hasn't changed)
              // BUT NOT the price system since product-variant-sync.js handles that
              if (matchingVariant.featured_media) {
                const productSection = document.querySelector('.js-product');
                if (productSection) {
                  // Dispatch both events to ensure media gallery updates
                  const mediaEvent = new CustomEvent('on:variant:change', {
                    detail: { variant: matchingVariant },
                    bubbles: true
                  });
                  productSection.dispatchEvent(mediaEvent);
                  
                  const mediaOnlyEvent = new CustomEvent('on:variant:change:media-only', {
                    detail: { variant: matchingVariant },
                    bubbles: true
                  });
                  productSection.dispatchEvent(mediaOnlyEvent);
                }
                
                const mediaGallery = document.querySelector('media-gallery');
                if (mediaGallery) {
                  const galleryEvent = new CustomEvent('on:variant:change', {
                    detail: { variant: matchingVariant },
                    bubbles: true
                  });
                  mediaGallery.dispatchEvent(galleryEvent);
                }
              }
            }
          }
        }, 50);
      }
    });
  });

  // Set initial states and make all options clickable
  
  // Make all size options clickable (remove disabled state)
  const allSizeInputs = document.querySelectorAll('input[data-option-name="Size"]');
  allSizeInputs.forEach(input => {
  input.disabled = false;
  const label = document.querySelector(`label[for="${input.id}"]`);
  if (label) {
      label.style.cursor = 'pointer';
  }
  });
  
  // Set initial swatch option state (Color, Style, etc.)
  // Find the first swatch option that's checked

  const allSwatchInputs = document.querySelectorAll('input[data-option-name]');

  // Check productData

  // Debug: Log all inputs and their states
  const allInputsDebug = [];
  allSwatchInputs.forEach(input => {
    const label = document.querySelector(`label[for="${input.id}"]`);
    const isSwatch = label && label.classList.contains('opt-label--swatch');
    const isChecked = input.checked;
    allInputsDebug.push({
      id: input.id,
      optionName: input.dataset.optionName,
      value: input.value,
      checked: isChecked,
      hasLabel: !!label,
      labelClasses: label?.className,
      isSwatch: isSwatch
    });
  });

  let checkedSwatchInput = null;
  let checkedSwatchOptionName = null;
  
  allSwatchInputs.forEach(input => {
    const label = document.querySelector(`label[for="${input.id}"]`);
    const isSwatch = label && label.classList.contains('opt-label--swatch');
    const isChecked = input.checked;

    if (isSwatch && isChecked) {
      checkedSwatchInput = input;
      checkedSwatchOptionName = input.dataset.optionName;
    }
  });
  
  // If no checked swatch found, try finding any checked input and check if its label is a swatch
  if (!checkedSwatchInput) {
    const allCheckedInputs = document.querySelectorAll('input[data-option-name]:checked');

    allCheckedInputs.forEach(input => {
      const label = document.querySelector(`label[for="${input.id}"]`);
      const isSwatch = label && label.classList.contains('opt-label--swatch');

      if (isSwatch && !checkedSwatchInput) {
        checkedSwatchInput = input;
        checkedSwatchOptionName = input.dataset.optionName;
      }
    });
  }
  
  // Fallback: Check if any option name matches swatch option names from settings
  // Or check by looking at all labels with swatch class
  if (!checkedSwatchInput) {
    // Method 1: Find any label with opt-label--swatch class and get its input
    const allSwatchLabels = document.querySelectorAll('.opt-label--swatch');

    allSwatchLabels.forEach(label => {
      const inputId = label.getAttribute('for');
      if (inputId) {
        const input = document.getElementById(inputId);
        if (input && input.checked && !checkedSwatchInput) {
          checkedSwatchInput = input;
          checkedSwatchOptionName = input.dataset.optionName;
        }
      }
    });
    
    // Method 2: Treat the FIRST option as the swatch option (Style, Color, etc.)
    // This works even if it's rendered as buttons instead of swatches
    if (!checkedSwatchInput && window.productData && window.productData.optionNames && window.productData.optionNames.length > 0) {
      const firstOptionName = window.productData.optionNames[0];

      checkedSwatchInput = document.querySelector(`input[data-option-name="${firstOptionName}"]:checked`);
      if (checkedSwatchInput) {
        checkedSwatchOptionName = firstOptionName;

      }
    }
    
    // Method 3: Fallback to Color/Colour for backward compatibility
    if (!checkedSwatchInput) {
      checkedSwatchInput = document.querySelector('input[data-option-name="Color"]:checked, input[data-option-name="Colour"]:checked');
      if (checkedSwatchInput) {
        checkedSwatchOptionName = checkedSwatchInput.dataset.optionName;

      }
    }
  }
  
  if (checkedSwatchInput && checkedSwatchOptionName && window.productData && window.productData.optionNames) {
    // Update availability of all other options based on the selected swatch option
    window.productData.optionNames.forEach(optionToUpdate => {
      if (optionToUpdate !== checkedSwatchOptionName) {
        updateOptionAvailability(optionToUpdate, checkedSwatchOptionName, checkedSwatchInput.value);
      }
    });

    // Update color/style text display (works for any swatch option)
    const colorTextElement = document.querySelector('.js-color-text');
    if (colorTextElement) {
      colorTextElement.textContent = checkedSwatchInput.value;
    }

    // Set visual selection on swatch
    const selectedSwatch = document.querySelector(`label[for="${checkedSwatchInput.id}"]`);
    if (selectedSwatch) {
      selectedSwatch.classList.add('is-selected');
    }
  } else {

    // Debug: Try to manually find and initialize

    if (window.productData && window.productData.optionNames && window.productData.optionNames.length > 0) {
      const firstOptionName = window.productData.optionNames[0];
      const allFirstOptionInputs = document.querySelectorAll(`input[data-option-name="${firstOptionName}"]`);
      const checkedFirstOptionInputs = Array.from(allFirstOptionInputs).filter(inp => inp.checked);

      if (checkedFirstOptionInputs.length > 0) {
        const manualCheckedInput = checkedFirstOptionInputs[0];

        window.productData.optionNames.forEach(optionToUpdate => {
          if (optionToUpdate !== firstOptionName) {
            updateOptionAvailability(optionToUpdate, firstOptionName, manualCheckedInput.value);
          }
        });
      }
    }
  }
  
  // Add a global debug function that can be called from console
  window.debugVariantState = function() {
    if (window.productData && window.productData.optionNames) {
      const firstOptionName = window.productData.optionNames[0];
      const checkedFirstOption = document.querySelector(`input[data-option-name="${firstOptionName}"]:checked`);

      if (checkedFirstOption) {
        window.productData.optionNames.forEach(optionToUpdate => {
          if (optionToUpdate !== firstOptionName) {
            updateOptionAvailability(optionToUpdate, firstOptionName, checkedFirstOption.value);
          }
        });
      }
    }
    
    // Check current state of all size inputs
    const allSizeInputs = document.querySelectorAll('input[data-option-name="Size"]');

    allSizeInputs.forEach(input => {
      const label = document.querySelector(`label[for="${input.id}"]`);

    });

  };

  // Set initial size state
  const checkedSizeInput = document.querySelector('input[data-option-name="Size"]:checked');
  if (checkedSizeInput) {
  // Update size text display
  const sizeTextElement = document.querySelector('.js-size-text');
  if (sizeTextElement) {
      sizeTextElement.textContent = checkedSizeInput.value;
  }

  // Set visual selection on size option
  const selectedSizeLabel = document.querySelector(`label[for="${checkedSizeInput.id}"]`);
  if (selectedSizeLabel) {
      selectedSizeLabel.classList.add('is-selected');
  }
  }

  // Set visual states for all initially checked options
  const allCheckedInputs = document.querySelectorAll('input[data-option-name]:checked');
  allCheckedInputs.forEach(input => {
  const label = document.querySelector(`label[for="${input.id}"]`);
  if (label) {
      label.classList.add('is-selected');
  }
  });
  
  // Monitor if media gallery is receiving our events
  const mediaGallery = document.querySelector('media-gallery');
  if (mediaGallery) {
  // Listen for our dispatched events to see if they're being received
  mediaGallery.addEventListener('on:variant:change:media-only', function(e) {
      if (e.detail && e.detail.variant && e.detail.variant.featured_media) {
      // Check if there's a matching image element
      const matchingImage = document.querySelector(`[data-media-id="${e.detail.variant.featured_media.id}"]`);
      if (matchingImage) {
          // Image found and activated
      } else {
          // Image not found - could add fallback logic here if needed
      }
      }
  });
  } else {
  // No media-gallery element found - could add fallback logic here if needed
  }

  // Initial variant availability check on load
  const variantIdInput = document.querySelector('input[name="id"]');
  if (variantIdInput) {
    const currentVariantId = parseInt(variantIdInput.value);
    const currentVariant = window.productData.variants.find(v => v.id === currentVariantId);
    if (currentVariant) {
      const addToCartBtn = document.querySelector('[name="add"], .product-form__cart-submit');
      if (addToCartBtn) {
        addToCartBtn.disabled = !currentVariant.available;
        if (!currentVariant.available) {
          addToCartBtn.textContent = 'Sold Out';
        } else {
          addToCartBtn.textContent = 'Add to Cart';
        }
      }
    }
  }

}); // End of DOMContentLoaded

// Also set up listeners immediately if DOM is already loaded
if (document.readyState !== 'loading') {
  // The DOMContentLoaded handler will also run, but this ensures we catch early clicks
}

// Enhanced general change handler with logging
document.addEventListener('change', function(e) {
  if (e.target.matches('input[data-option-name]')) {
    const optionName = e.target.dataset.optionName;
    const optionPosition = e.target.dataset.optionPosition;
    const selectedValue = e.target.value;

    const labelValueSpan = document.querySelector(`.option-selector__label-value[data-option-position="${optionPosition}"]`);
    if (labelValueSpan) {
      labelValueSpan.textContent = selectedValue;
    }

    // Update visual selection for any option type
    const allLabelsInGroup = document.querySelectorAll(`input[data-option-name="${optionName}"] + label`);
    allLabelsInGroup.forEach(label => {
    label.classList.remove('is-selected');
    });
    
    const currentLabel = document.querySelector(`label[for="${e.target.id}"]`);
    if (currentLabel) {
    currentLabel.classList.add('is-selected');
    }

    // Update size text display
    if (optionName === 'Size') {
      const sizeTextElement = document.querySelector('.js-size-text');
      if (sizeTextElement) {
        sizeTextElement.textContent = selectedValue;
      }
    }

    // VARIANT SYNC for size changes
    setTimeout(() => {
      const selectedOptions = {};
      document.querySelectorAll('input[data-option-name]:checked').forEach(inp => {
        selectedOptions[inp.dataset.optionName] = inp.value;
      });
      
      let matchingVariant = null;
      if (window.productData && window.productData.variants) {
        for (const variant of window.productData.variants) {
          let matches = true;
          
          Object.keys(selectedOptions).forEach(optionName => {
            const optionIndex = window.productData.optionNames.indexOf(optionName);
            if (optionIndex >= 0) {
              const variantOptionValue = variant.options[optionIndex];
              if (variantOptionValue !== selectedOptions[optionName]) {
                matches = false;
              }
            }
          });
          
          if (matches) {
            matchingVariant = variant;
            break;
          }
        }
      }
      
      if (matchingVariant) {
        const variantIdInput = document.querySelector('input[name="id"]');
        if (variantIdInput) {
          variantIdInput.value = matchingVariant.id;
        }
        
        // Update URL with both variant and size parameters
        const currentUrl = new URL(window.location);
        currentUrl.searchParams.set('variant', matchingVariant.id);
        
        // Update size parameter to match the actual selected size
        if (matchingVariant.options && matchingVariant.options[1]) { // sizeIdx = 1
          currentUrl.searchParams.set('size', matchingVariant.options[1]);
        }
        
        window.history.replaceState(null, '', currentUrl.toString());
        
        // Trigger media gallery if variant has featured media
        // BUT NOT the price system since product-variant-sync.js handles that
        if (matchingVariant.featured_media) {
          const productSection = document.querySelector('.js-product');
          if (productSection) {
            // Dispatch both events to ensure media gallery updates
            const mediaEvent = new CustomEvent('on:variant:change', {
              detail: { variant: matchingVariant },
              bubbles: true
            });
            productSection.dispatchEvent(mediaEvent);
            
            const mediaOnlyEvent = new CustomEvent('on:variant:change:media-only', {
              detail: { variant: matchingVariant },
              bubbles: true
            });
            productSection.dispatchEvent(mediaOnlyEvent);
          }
        }
      } else {

      }
    }, 50);
  }
});

// Listen for all option changes to update displays
// Use capture phase to catch events before they might be stopped
document.addEventListener('change', function(e) {
  // Check if this is a radio button change
  if (e.target.type === 'radio' && e.target.dataset?.optionName) {
  }
  
  // Detect if this is a swatch option (Color, Style, etc.)
  // Check both: 1) label has swatch class, OR 2) it's the first option (by position)
  const changedInput = e.target;

  if (changedInput.matches('input[data-option-name]')) {
    const changedOptionName = changedInput.dataset.optionName;
    const changedLabel = document.querySelector(`label[for="${changedInput.id}"]`);
    const hasSwatchClass = changedLabel && changedLabel.classList.contains('opt-label--swatch');
    
    // Check if it's the first option (Style, Color, etc. - the one that controls other options)
    const firstOptionName = window.productData?.optionNames?.[0];
    const isFirstOption = window.productData && 
                          window.productData.optionNames && 
                          window.productData.optionNames.length > 0 &&
                          firstOptionName === changedOptionName;
    
    const isSwatchOption = hasSwatchClass || isFirstOption;

    // If this is a swatch option change, update availability of other options
    if (isSwatchOption && window.productData && window.productData.optionNames) {
      // Find all other options that should be updated
      window.productData.optionNames.forEach(optionToUpdate => {
        if (optionToUpdate !== changedOptionName) {
          updateOptionAvailability(optionToUpdate, changedOptionName, changedInput.value);
        }
      });
    } else {

    }
  } else {

  }

// Legacy Color/Colour handler - keeping for backward compatibility but now handled above
if (e.target.matches('input[data-option-name="Color"], input[data-option-name="Colour"]')) {
    updateOptionAvailability('Size', 'Color', e.target.value);
}

// Handle other option changes (like direct radio button clicks)
if (e.target.matches('input[data-option-name]')) {
    const optionName = e.target.dataset.optionName;
    
    // Update visual selection for any option type
    const allLabelsInGroup = document.querySelectorAll(`input[data-option-name="${optionName}"] + label`);
    allLabelsInGroup.forEach(label => {
    label.classList.remove('is-selected');
    });
    
    const currentLabel = document.querySelector(`label[for="${e.target.id}"]`);
    if (currentLabel) {
    currentLabel.classList.add('is-selected');
    }
    
    // Trigger URL update for size changes
    if (optionName === 'Size') {
        setTimeout(() => {
            const selectedOptions = {};
            document.querySelectorAll('input[data-option-name]:checked').forEach(inp => {
                selectedOptions[inp.dataset.optionName] = inp.value;
            });
            
            let matchingVariant = null;
            if (window.productData && window.productData.variants) {
                for (const variant of window.productData.variants) {
                    let matches = true;
                    
                    Object.keys(selectedOptions).forEach(optionName => {
                        const optionIndex = window.productData.optionNames.indexOf(optionName);
                        if (optionIndex >= 0) {
                            const variantOptionValue = variant.options[optionIndex];
                            if (variantOptionValue !== selectedOptions[optionName]) {
                                matches = false;
                            }
                        }
                    });
                    
                    if (matches) {
                        matchingVariant = variant;
                        break;
                    }
                }
            }
            
            if (matchingVariant) {
                const variantIdInput = document.querySelector('input[name="id"]');
                if (variantIdInput) {
                    variantIdInput.value = matchingVariant.id;
                }
                
                // Update URL with both variant and size parameters
                const currentUrl = new URL(window.location);
                currentUrl.searchParams.set('variant', matchingVariant.id);
                
                // Update size parameter to match the actual selected size
                if (matchingVariant.options && matchingVariant.options[1]) { // sizeIdx = 1
                  currentUrl.searchParams.set('size', matchingVariant.options[1]);
                }
                
                window.history.replaceState(null, '', currentUrl.toString());
            } else {
            }
        }, 10);
    }
}
});

// Listen for clicks on swatch labels (Color, Style, etc.)
// Also handle clicks on first option labels even if they're buttons
document.addEventListener('click', function(e) {
  const isSwatchLabel = e.target.matches('.opt-label--swatch');
  const inputId = e.target.getAttribute('for');
  const input = inputId ? document.getElementById(inputId) : null;
  const isFirstOption = input && 
                        window.productData && 
                        window.productData.optionNames && 
                        window.productData.optionNames.length > 0 &&
                        window.productData.optionNames[0] === input.dataset.optionName;

  if (isSwatchLabel || isFirstOption) {
    if (input && input.dataset.optionName && window.productData && window.productData.optionNames) {
      const clickedOptionName = input.dataset.optionName;

      // Update availability of all other options when a swatch option is clicked
      window.productData.optionNames.forEach(optionToUpdate => {
        if (optionToUpdate !== clickedOptionName) {
          updateOptionAvailability(optionToUpdate, clickedOptionName, input.value);
        }
      });
    } else {

    }
  }
});
